<template>
  <div class="eff_main animated slideInLeft">
    <div class="flex_bet_h tools_titmod">
      <span class="tools_tit">选择音效</span>
      <img
        src="../../assets/images/img2/offlogin.png"
        class="tools_off"
        @click="overSelect"
      />
    </div>
    <div class="flex_bet_h eff_con">
      <div class="eff_tab">
        <div
          class="eff_tabli"
          :class="tab_index == index ? 'eff_tabli_act' : ''"
          v-for="(item, index) in list"
          :key="index"
          @click="tab_index = index"
        >
          {{ item.catname }}
        </div>
      </div>
      <div class="eff_list_con">
        <div class="eff_list"
          v-for="(item, index) in list"
          :key="index"
          v-if="tab_index == index"
        >
          <div
            class="audio_selli eff_list_li"
            v-for="(item2, index2) in item.list"
            :key="index2"
            @click="addSelestList(index2)"
          >
            <img
              src="../../assets/images/pause.png"
              class="audio_selliplay"
              @click.stop="play_audio.play(item2.url)"
              v-if="play_audio.audiourl == item2.url"
            />
            <img
              class="audio_selliplay"
              src="../../assets/images/play.png"
              @click.stop="play_audio.play(item2.url)"
              v-else
            />
            <div class="audio_sellicon">
              <p class="overflow_hide">{{ item2.name }}</p>
            </div>
            <div class="audio_selstate" v-if="judgeInSelectList(index2)"></div>
            <img
              src="../../assets/images/img2/select.png"
              class="audio_selicon"
              v-else
            />
          </div>
        </div>
        <div class="ausel_detbtn ausel_detbtn2" @click="overSelect">确认选择</div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayListAudio from "../../utils/PlayListAudio.js";
export default {
  data() {
    return {
      list: [], //音效列表
      tab_index: 0, //分类选中索引
      play_audio: new PlayListAudio(), //播放器对象
      select_list: [], //选择的文件索引列表
    };
  },
  mounted() {
    this.getSoundEffect();
  },
  destroyed() {
    this.play_audio.stop();
  },
  computed: {
    // 判断文件是否在索引列表里面
    judgeInSelectList(index) {
      return (index) => {
        return this.select_list.indexOf(index) > -1 ? false : true;
      };
    },
  },
  methods: {
    // 关闭事件
    overSelect() {
      let list = [];
      this.select_list.forEach((item) => {
        this.list[this.tab_index].list[item].type = "sound";
        list.push(this.list[this.tab_index].list[item]);
      });
      this.$emit("overSelect", list);
    },
    // 选择文件
    addSelestList(index) {
      let index_in = this.select_list.indexOf(index);
      // 如果索引存在就删除不存在就添加
      index_in == -1
        ? this.select_list.push(index)
        : this.select_list.splice(index_in, 1);
    },
    // 获取音效列表
    getSoundEffect() {
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qrysoundeffects;
      this.$request.postHttp({}, url, (decData) => {
        self.list = decData.model;
      });
    },
  },
};
</script>

<style scoped>
@import url("../../assets/css/tools.css");
</style>


// WEBPACK FOOTER //
// src/components/tools/sound_effect.vue